import React from 'react';
import { useDispatch } from 'react-redux';
import { setReleaseNotesVisible } from '../../actions/layout';
import { APP_VERSION, APP_VERSION_D } from '../../config';
import logoImg from '../../static/pcStore.png';
import styles from './ReleaseNotes.module.less';
import { cacheKeys } from '../../constants/storageKeys';

const ReleaseNotes = () => {
  const dispatch = useDispatch();
  const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
  const startInfo = JSON.parse(startInfoStr || '{}');
  return (
    <div className={styles.ReleaseNotes}>
      <span
        className="icon close"
        onClick={() => {
          dispatch(setReleaseNotesVisible(false));
        }}
      >
        <i className="iconfont icon-close" />
      </span>
      <div className="top">
        <img src={logoImg} alt="" className="logo" />
        联想应用商店
      </div>
      <div className="header">
        <div className="title">版本特性与功能</div>
      </div>
      <div className="cont">
        <div className="ver">
          <span className="name">版本：</span>
          <span className="val">{startInfo.isDStore ? APP_VERSION_D : APP_VERSION}</span>
        </div>
        <div className="list">
          <div className="item">
            <span className="num">1.</span>
            <span className="text">搜索体验升级，支持AI搜应用;</span>
          </div>
          <div className="item">
            <span className="num">2.</span>
            <span className="text">折扣商城频道上新，低价好物任你挑;</span>
          </div>
          <div className="item">
            <span className="num">3.</span>
            <span className="text">大量新游上架，尽享游戏乐趣;</span>
          </div>
          <div className="item">
            <span className="num">4.</span>
            <span className="text">新增托盘，主要入口快速直达。</span>
          </div>
          {/* <div className="item">
            <span className="num">5.</span>
            <span className="text">商店窗口尺寸支持自由拖动与最大化了，快来试试吧。</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
